/* eslint-disable no-mixed-operators */
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CustomerNotification, DashboardTabType, defaultChangedDateInfo } from "../../../types";
import { AppDispatch } from "../../../redux/store";
import { RootState } from "../../../redux/reducers";
import { toggleDrawer } from "../../../redux/reducers/notification.reducer";
import { selectNotificationDetails } from "../../../redux/selectors/notification.selector";
import { markAsRead } from "../../../redux/actions/notification.action";
import { selectAuthDetails } from "../../../redux/selectors";
import { useNavigate } from "react-router-dom";
import { contractDetails } from "../../../redux/actions/contracts.action";
import { switchDashboardTab } from "../../../redux/reducers/shared.reducer";
import { setChangedDateInfo } from "../../../redux/reducers/payment.reducer";
import './notifications.scss';

const NotificationDrawer = () => {
  const dispatch = useDispatch<AppDispatch>();
  let { notifications, isDrawerOpen, unread_count } = useSelector((state: RootState) =>
    selectNotificationDetails(state)
  );

  const navigate = useNavigate();

  const { user } = useSelector((state: RootState) =>
    selectAuthDetails(state)
  );

  const drawerRef = useRef<HTMLDivElement>(null);

  const handleMarkAsRead = (notify: CustomerNotification) => {
    if(user?.patient_id){
      dispatch(markAsRead({ bn_id: notify.bn_id, patient_id: user?.patient_id }));
    }
  };

   const handleMarkAllRead = () => {
    if(user?.patient_id){
      dispatch(markAsRead({ bn_id: 0, patient_id: user?.patient_id }));
    }
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target as Node)) {
      dispatch(toggleDrawer()); // Close the drawer
    }
  };
  const [showAllNotification, setShowAllNotification] = useState(true);
  useEffect(() => {
    
    if (isDrawerOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDrawerOpen]);

  const selectContract = (notify: CustomerNotification) => {
    if(notify?.metadata?.contract_id){
      const data = { id: notify?.metadata?.contract_id, navigate };
      dispatch(contractDetails({ data }))
      dispatch(switchDashboardTab(DashboardTabType.OVERVIEW));
      dispatch(setChangedDateInfo(defaultChangedDateInfo));  
    }
    handleMarkAsRead(notify);
    dispatch(toggleDrawer());
  }
  const covertDateTimesAgo = (sent_date: any) => {
    let date = new Date(sent_date);
    var seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    if (seconds < 5) {
      return "just now";
    } else if (seconds < 60) {
      return seconds + " seconds ago";
    }
    else if (seconds < 3600) {
      var minutes = Math.floor(seconds / 60)
      if (minutes > 1)
        return minutes + " minutes ago";
      else
        return "1 minute ago";
    }
    else if (seconds < 86400) {
      var hours = Math.floor(seconds / 3600)
      if (hours > 1)
        return hours + " hours ago";
      else
        return "1 hour ago";
    }
    //2 days and no more
    else if (seconds < 172800) {
      var days = Math.floor(seconds / 86400)
      if (days > 1)
        return days + " days ago";
      else
        return "1 day ago";
    }
    else {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? 0 + minutes : minutes;
      return months[date.getMonth()] + " " + date.getDate().toString() + " at " + ('0' + hours).slice(-2) + ":" + ('0' + minutes).slice(-2) + ampm;
    }
  }
    
  let unread_notifications = notifications.filter((n) => n.read_at === null); 
  
  notifications = notifications.map(element => ({
    ...element,
    show_sent_at: covertDateTimesAgo(element.sent_at)
  }));
  unread_notifications = unread_notifications.map(element => ({
    ...element,
    show_sent_at: covertDateTimesAgo(element.sent_at)
  }));

  return (
    <div> 
    {isDrawerOpen && <div className="overlay"></div>}
    <div
      ref={drawerRef}
      className={`offcanvas offcanvas-end ${isDrawerOpen ? "show" : ""}`}
      tabIndex={-1}
      style={{
        visibility: isDrawerOpen ? "visible" : "hidden",
        transition: "visibility 0.3s ease, transform 0.3s ease",
        transform: isDrawerOpen ? "translateX(0)" : "translateX(100%)",
      }}
      role="dialog"
    >
    
      <div className="offcanvas-header position-relative px-0 d-block pb-0">
        {/* <button type="button" className="btn-close position-absolute top-0 end-0" onClick={() => dispatch(toggleDrawer())} ></button> */}
        <div className="d-flex align-items-center justify-content-between mb-4 w-100 px-3">
          <h5 className="fs-18 fw-700 m-0 black-16">Notifications</h5>
          {/* <p className="fs-14 fw-600 text-blue m-0 text-primary cursor_pointer" onClick={handleMarkAllRead}>
            {" "}
            Mark all Read
          </p> */}
          <img src="../../assets/images/cross-circle.png"  className="hw-40 pointer" alt="" onClick={() => dispatch(toggleDrawer())} />
        </div>
        <div className="w-100 d-flex align-items-center border-bottom justify-content-between">
          <div className="d-flex align-items-center">
          <p className={`fs-14 fw-600 m-0 pb-2 px-4 position-relative notification-tab d-flex ${showAllNotification ? 'active' : '' }`}  onClick={() => setShowAllNotification(true)}>
            All{" "}
            <span className="counter fs-10 fw-700 text-white px-1 d-block ms-2" >
              {unread_count}
            </span>
          </p>
          <p className={`fs-14 fw-600 m-0 pb-2 px-4 position-relative notification-tab  ${!showAllNotification ? 'active' : '' }`} onClick={() => setShowAllNotification(false)}>
            Unread
          </p>
          </div>
          <p className="fs-14 fw-600 text-blue m-0 text-primary cursor_pointer me-3 pb-2" onClick={handleMarkAllRead}>
            {" "}
            { unread_count > 0 && ('Mark all Read')}
          </p>
        </div>
      </div>
      <div className="offcanvas-body">
        {showAllNotification && notifications.length > 0 || !showAllNotification && unread_notifications.length > 0 ? (
          <div className="list-group">
            {(showAllNotification ? notifications : unread_notifications).map((notify: CustomerNotification) => (
              <div
                key={notify.bn_id}
                className={`list-group-item notification-msg border-0 radius-8 m-0 mb-2 ${ !notify.read_at ? "unread" : ""}`}
                onClick={() => selectContract(notify)}
              >
                <h5 className="fs-14 fw-700 m-0 black-24">{notify.title}</h5>
                <span className="fs-14 fw-605 grey-106 m-0 mt-1">{notify.message}</span>
                <span className="fs-14 fw-605 grey-106 m-0 mt-1">{notify.show_sent_at}</span>
              </div>
            ))}
          </div>
        ) : (
          // <p className="text-center text-muted">No notifications</p>
          <div className="w-100 d-flex align-items-center justify-content-center flex-column mt-5">
            <img src="../../assets/images/no-notification.svg" className="" alt="" />
            <p className="text-center fs-14 fw-400 text-muted mt-3">{!showAllNotification ? 'No unread or new notifications found.' : 'No notifications found.'}</p>
          </div>
        )}
      </div>
    </div>
    </div>
  );
};

export default NotificationDrawer;
